import { useEffect, useRef } from "react";

// Injects the 300x250 display ad; scripts inside JSX don't execute, so we build the DOM manually.
export default function AdBox({ className = "" }) {
  const ref = useRef(null);

  useEffect(() => {
    const host = ref.current;
    if (!host) return;
    const ins = document.createElement("ins");
    ins.style.width = "300px";
    ins.style.height = "250px";
    ins.style.display = "block";
    ins.className = "m29df07bd93";
    ins.setAttribute("data-width", "300");
    ins.setAttribute("data-height", "250");
    ins.setAttribute("data-domain", "//data527.click");
    ins.setAttribute("data-affquery", "/5f42376ac5ae5d3d6467/29df07bd93/?placementName=default");
    const s = document.createElement("script");
    s.src = "//data527.click/js/responsive.js";
    s.async = true;
    ins.appendChild(s);
    host.appendChild(ins);
    return () => { host.innerHTML = ""; };
  }, []);

  return (
    <div className={`flex flex-col items-center gap-2 ${className}`} data-testid="ad-box">
      <span className="font-ui text-[10px] tracking-caps text-muted-foreground">advertisement</span>
      <div ref={ref} className="w-[300px] h-[250px] rounded-md border border-dashed border-border bg-secondary/40 overflow-hidden" />
    </div>
  );
}
